import React, { useMemo } from "react";
import { get } from "lodash";
import { required, TextInput } from "react-admin";
import { useFormState } from "react-final-form";
import { useSelector } from "react-redux";

const ProjectDocTypeCustomInput = (props) => {
  const form = useFormState();
  const { projectDocTypes } = useSelector((state) => ({
    projectDocTypes: Object.values(
      get(state, "admin.resources.project-doc-types.data", [])
    ),
  }));
  const projectDocTypeId = get(form, "values.project_doc_type_id", 0);
  const showCustomCategory = useMemo(() => {
    if (projectDocTypeId === 0) {
      return false;
    }
    const category = projectDocTypes.find((cat) => cat.id === projectDocTypeId);
    if (category && category.is_custom) {
      return true;
    }

    return false;
  }, [projectDocTypeId, projectDocTypes]);

  if (!showCustomCategory) {
    return null;
  }

  return <TextInput {...props} maxLength={100} validate={required()} />;
};

export default ProjectDocTypeCustomInput;
